import _regeneratorRuntime from "/codebuild/output/src1835255143/src/www-public/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import { createInlineWorkerFactory } from './_rollup-plugin-web-worker-loader__helper__browser__createInlineWorkerFactory.js';
var WorkerFactory = createInlineWorkerFactory(
/* rollup-plugin-web-worker-loader */
function () {
  (function () {
    '__worker_loader_strict__';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
      Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
          resolve(value);
        });
      }

      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }

        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }

        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }

        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    }
    /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */


    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // Use a lookup table to find the index.

    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);

    for (var i = 0; i < chars.length; i++) {
      lookup[chars.charCodeAt(i)] = i;
    }

    var encode = function encode(arraybuffer) {
      var bytes = new Uint8Array(arraybuffer),
          i,
          len = bytes.length,
          base64 = '';

      for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
      }

      if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
      } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
      }

      return base64;
    };

    var lastBlobMap = new Map();
    var transparentBlobMap = new Map();

    function getTransparentBlobFor(width, height, dataURLOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var id, offscreen, blob, arrayBuffer, base64;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = "".concat(width, "-").concat(height);

                if (!('OffscreenCanvas' in globalThis)) {
                  _context.next = 17;
                  break;
                }

                if (!transparentBlobMap.has(id)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", transparentBlobMap.get(id));

              case 4:
                offscreen = new OffscreenCanvas(width, height);
                offscreen.getContext('2d');
                _context.next = 8;
                return offscreen.convertToBlob(dataURLOptions);

              case 8:
                blob = _context.sent;
                _context.next = 11;
                return blob.arrayBuffer();

              case 11:
                arrayBuffer = _context.sent;
                base64 = encode(arrayBuffer);
                transparentBlobMap.set(id, base64);
                return _context.abrupt("return", base64);

              case 17:
                return _context.abrupt("return", '');

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }

    var worker = self;

    worker.onmessage = function (e) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _e$data, id, bitmap, width, height, dataURLOptions, transparentBase64, offscreen, ctx, blob, type, arrayBuffer, base64;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!('OffscreenCanvas' in globalThis)) {
                  _context2.next = 31;
                  break;
                }

                _e$data = e.data, id = _e$data.id, bitmap = _e$data.bitmap, width = _e$data.width, height = _e$data.height, dataURLOptions = _e$data.dataURLOptions;
                transparentBase64 = getTransparentBlobFor(width, height, dataURLOptions);
                offscreen = new OffscreenCanvas(width, height);
                ctx = offscreen.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                bitmap.close();
                _context2.next = 9;
                return offscreen.convertToBlob(dataURLOptions);

              case 9:
                blob = _context2.sent;
                type = blob.type;
                _context2.next = 13;
                return blob.arrayBuffer();

              case 13:
                arrayBuffer = _context2.sent;
                base64 = encode(arrayBuffer);
                _context2.t0 = !lastBlobMap.has(id);

                if (!_context2.t0) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 19;
                return transparentBase64;

              case 19:
                _context2.t1 = _context2.sent;
                _context2.t2 = base64;
                _context2.t0 = _context2.t1 === _context2.t2;

              case 22:
                if (!_context2.t0) {
                  _context2.next = 25;
                  break;
                }

                lastBlobMap.set(id, base64);
                return _context2.abrupt("return", worker.postMessage({
                  id: id
                }));

              case 25:
                if (!(lastBlobMap.get(id) === base64)) {
                  _context2.next = 27;
                  break;
                }

                return _context2.abrupt("return", worker.postMessage({
                  id: id
                }));

              case 27:
                worker.postMessage({
                  id: id,
                  type: type,
                  base64: base64,
                  width: width,
                  height: height
                });
                lastBlobMap.set(id, base64);
                _context2.next = 32;
                break;

              case 31:
                return _context2.abrupt("return", worker.postMessage({
                  id: e.data.id
                }));

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
  })();
}, null);
/* eslint-enable */

export { WorkerFactory as default };